import win from "../../assets/win.png";
import letter from "../../assets/letter.png";
import internetExplorer from "../../assets/internetExplorer.png";
import mailExchange from "../../assets/mailExchange.png";
import tree from "../../assets/tree.png";
import keyring from "../../assets/keyring.png";
import broadBand from "../../assets/broadband.png";

import React, {useEffect, useState} from "react";
import useWindowDimensions from "../../helpers/windowDimensions";

function TaskBar() {
  const {height, width} = useWindowDimensions();
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer)
    }

  });

  return (
    <div className="task-bar" style={taskBarStyle.root}>
      <div style={taskBarStyle.leftGroup}>
        <button style={taskBarStyle.startButton}>
          <img src={win} alt="start" />
          <b style={{fontSize: '1.5em'}}>Start</b>
        </button>
        <TaskBarSpacer />
        <img src={letter} alt="letter" style={taskBarStyle.iconButton} />
        { width > 560 ?
            (
            <div style={taskBarStyle.leftGroup}>
              <img src={internetExplorer} alt="letter" style={taskBarStyle.iconButton} />
              <img src={mailExchange} alt="letter" style={taskBarStyle.iconButton} />
            </div>
        ) : (
            <div className="title-bar-controls">
              <button aria-label="Restore"></button>
            </div>
      )}
        <TaskBarSpacer />
        {/* Put active window here */}
        {ActiveWindowButton(tree, "DopeShop.exe")}
      </div>
      <div style={taskBarStyle.rightGroup}>
        <TaskBarSpacer />
        <div className="status-bar pressedButton" style={{height: '85%'}}>
            <div className="status-bar-field" style={taskBarStyle.iconArea}>
              <img src={keyring} alt="keyring" style={{height: '80%'}}/>
              <img src={broadBand} alt="broadBand" style={{height: '80%'}}/>
              <div style={{width: '10px'}} />
              <p style={{fontSize: '1.3em'}}>{date.toLocaleTimeString('fi-FI', {
                hour: '2-digit',
                minute: '2-digit',
              })}</p>
            </div>
        </div>
      </div>
    </div>
  );
}

function TaskBarSpacer() {
  return (
      <div className="status-bar" style={{width: '1px', height: '90%', margin: '0 10px'}}>
        <div className="status-bar-field" ></div>
      </div>
  );
}

function ActiveWindowButton(image: string, title: string): JSX.Element {
  const {height, width} = useWindowDimensions();

  return (
      <button style={taskBarStyle.activeWindow} className="pressedButton">
        <img src={image} alt="tree" style={{margin: "0px 5px 0 -5px", height: '70%'}}/>
        {width > 500 ? (
            <b style={{fontSize: '1.3em'}}>{title}</b>
        ) : (
            <b style={{fontSize: '1.3em'}}>{title.slice(0, 2) + '...'}</b>
        )}

      </button>
  );

}

const taskBarStyle = {
  root: {
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "calc(100% - 3px)",
    width: "100%",
    backgroundColor: "#b6b8b7",
    paddingTop: "3px",
  },
  startButton: {
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "90%",
    marginLeft: "4px",
  },
  leftGroup: {
    height: "100%",

    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  iconButton: {
    height: "70%",
    margin: "0 5px",
  },
  activeWindow: {
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "90%",
  },
  rightGroup: {
    height: "100%",
    display: "flex",
    flexDirection: "row" as "row",
    alignItems: "center",
    marginRight: "10px",
  },
  iconArea: {
    display: "flex",
    flexDirection: "row" as "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
    width: "100%",
    padding: '0 10px'
  }

};

export default TaskBar;
